import { Dispatch, SetStateAction } from 'react';
import classes from './LabelsList.module.css';
import { LabelItem } from '../../LabelItem/LabelItem';
import { Label } from '../../../api/queries';

type LabelsListProps = {
  labels: Array<Label>;
  setSelectedLabels: Dispatch<SetStateAction<Array<Label>>>;
  selectedLabels: Array<Label>;
};

export const LabelsList = ({
  labels,
  setSelectedLabels,
  selectedLabels,
}: LabelsListProps) => {
  return (
    <div className={classes.labels}>
      {labels?.map((label) => {
        const isActiveLabel: boolean = selectedLabels.some(
          ({ id }) => id === label.id,
        );
        return (
          <LabelItem
            label={label}
            activeLabel={isActiveLabel}
            setSelectedLabels={setSelectedLabels}
            key={label.id}
          />
        );
      })}
    </div>
  );
};
